var styles = {"checkListInput":"styles_check-list-input__PevfR","checkListContainer":"styles_check-list-container__S2dGA","vertical":"styles_vertical__rTft8","horizontal":"styles_horizontal__BtOi0","noSpacing":"styles_no-spacing__gcA9N","compactSpacing":"styles_compact-spacing__5RGOk","comfortableSpacing":"styles_comfortable-spacing__nWA7B","looseSpacing":"styles_loose-spacing__BIM-U"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
